import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AppContext } from '@/App';

const AuthorisedRoute = ({ authorisedRoles }: { authorisedRoles: number[] }) => {
    const app = useContext(AppContext);
  
    if(authorisedRoles.includes(app.authLevel)) {
        return <Outlet />;
    } else {
        return <Navigate to="/" />; // Redirect to the home page
    }
};

  export default AuthorisedRoute;